(() => {
  class DreamHomeSearch {
    constructor(root) {
      this.root = root;
      this.input = root.querySelector('[data-dream-search-input]');
      this.results = root.querySelector('[data-dream-search-results]');
      this.abortController = null;
      this.timeout = null;

      if (!this.input || !this.results) return;

      this.input.addEventListener('input', this.onInput.bind(this));
      this.input.addEventListener('focus', () => {
        if (this.input.value.trim().length >= 2 && this.results.innerHTML.trim()) {
          this.root.classList.add('is-open');
        }
      });
      document.addEventListener('click', (event) => {
        if (!this.root.contains(event.target)) this.close();
      });
    }

    onInput() {
      window.clearTimeout(this.timeout);
      const query = this.input.value.trim();

      if (query.length < 2) {
        this.close(true);
        return;
      }

      this.timeout = window.setTimeout(() => this.fetchResults(query), 220);
    }

    async fetchResults(query) {
      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();
      this.root.classList.add('is-loading');

      const params = new URLSearchParams({
        q: query,
        'resources[type]': 'product',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,variants.title,vendor'
      });

      try {
        const response = await fetch(`/search/suggest.json?${params.toString()}`, {
          signal: this.abortController.signal,
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) throw new Error('Predictive search failed');

        const data = await response.json();
        const products = data?.resources?.results?.products || [];
        this.render(products, query);
      } catch (error) {
        if (error.name !== 'AbortError') this.render([], query);
      } finally {
        this.root.classList.remove('is-loading');
      }
    }

    render(products, query) {
      const safeQuery = this.escapeHtml(query);

      if (!products.length) {
        this.results.innerHTML = `
          <div class="dream-search-results__empty">
            No encontramos coincidencias para "${safeQuery}".
          </div>
        `;
        this.root.classList.add('is-open');
        return;
      }

      const productMarkup = products
        .map((product) => {
          const title = this.escapeHtml(product.title || 'Producto 3D Dream');
          const url = product.url || `/search?q=${encodeURIComponent(query)}&type=product`;
          const image = product.featured_image?.url || product.image || '';
          const price = this.formatPrice(product.price || product.price_min || '');
          const imageMarkup = image
            ? `<img src="${this.escapeAttribute(this.resizeImage(image, 120))}" alt="${title}" loading="lazy">`
            : `<span class="dream-search-results__placeholder">3D</span>`;

          return `
            <a class="dream-search-results__item" href="${this.escapeAttribute(url)}">
              <span class="dream-search-results__image">${imageMarkup}</span>
              <span class="dream-search-results__content">
                <strong>${title}</strong>
                ${price ? `<em>${this.escapeHtml(price)}</em>` : '<em>Ver producto</em>'}
              </span>
            </a>
          `;
        })
        .join('');

      this.results.innerHTML = `
        <div class="dream-search-results__head">Productos similares</div>
        ${productMarkup}
        <a class="dream-search-results__all" href="/search?q=${encodeURIComponent(query)}&type=product">
          Ver todos los resultados
        </a>
      `;
      this.root.classList.add('is-open');
    }

    close(clear = false) {
      this.root.classList.remove('is-open', 'is-loading');
      if (clear) this.results.innerHTML = '';
    }

    escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    escapeAttribute(value) {
      return this.escapeHtml(value);
    }

    formatPrice(value) {
      if (!value) return '';
      const amount = Number(String(value).replace(/[^0-9.]/g, ''));
      if (!Number.isFinite(amount)) return String(value);

      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        maximumFractionDigits: 0
      }).format(amount);
    }

    resizeImage(url, width) {
      if (!url) return '';
      const joiner = url.includes('?') ? '&' : '?';
      return `${url}${joiner}width=${width}`;
    }
  }

  const init = () => {
    document.querySelectorAll('[data-dream-search]').forEach((root) => new DreamHomeSearch(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
